import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "boxicons";
import "boxicons/css/boxicons.min.css";
import "./assets/styles.scss";

createApp(App).use(router).mount("#app");
